var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("dash-filter", {
        attrs: {
          options: _vm.filterOptions,
          default: _vm.queryString,
          loadingList: _vm.loadingList,
          action: _vm.action,
        },
        model: {
          value: _vm.queryString,
          callback: function ($$v) {
            _vm.queryString = $$v
          },
          expression: "queryString",
        },
      }),
      _c("div", { staticClass: "el-section" }, [
        _c(
          "div",
          {
            staticClass:
              "emd-container _highlight_header _header_spaced _footer_spaced_sm",
          },
          [
            _c(
              "div",
              { staticClass: "emd-container__header" },
              [
                _c("h2", { staticClass: "emd-text _size_section" }, [
                  _vm._v(" " + _vm._s(_vm.$t("recipients.list.title")) + " "),
                ]),
                !_vm.hasUserTwoFactorAuthentication
                  ? _c("emd-button", {
                      attrs: {
                        color: "primary",
                        text: _vm.$t("recipients.create.button"),
                      },
                      on: { click: _vm.openConfigMfaModal },
                    })
                  : _vm._e(),
                _vm.showCreatRecipient
                  ? _c(
                      "router-link",
                      {
                        staticClass:
                          "emd-btn _color_primary _size_small jsModalOpen",
                        attrs: {
                          to: { name: "recipientsCreate" },
                          tag: "button",
                        },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("recipients.create.button")) + " "
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm.loadingList
              ? _c(
                  "div",
                  {
                    staticClass:
                      "eu-display_flex eu-align-items_center_md eu-justify_center eu-pa_6",
                  },
                  [_c("emd-loader", { attrs: { type: "_invert" } })],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "emd-table-responsive" },
                  [
                    _c(
                      "Table",
                      {
                        attrs: {
                          fields: _vm.fields,
                          items: _vm.recipients.items,
                          toDetail:
                            this.permissionIsEnabled("recipients:get") &&
                            _vm.toDetail,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "text-transform": "initial",
                              "letter-spacing": "0",
                            },
                          },
                          [
                            _c("p", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("recipients.list.info.paragraph")
                                  ) +
                                  " "
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "emd-link",
                                  attrs: {
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    href: _vm.$sanitize(_vm.link),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("recipients.list.info.anchor")
                                    )
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]
                    ),
                    _vm.showEmptyList
                      ? _c("empty-list", {
                          attrs: {
                            entity: _vm.emptyData.entity,
                            svg: _vm.emptyData.svg,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
            !_vm.loadingList
              ? _c("pagination", {
                  attrs: {
                    pagination: _vm.recipients.pagination,
                    totalShowing: _vm.totalItems,
                    type: "list",
                    action: _vm.action,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }